import { useQueryClient, useMutation } from 'react-query';
import { useAxiosInstance } from '../../common';
import { SapConfig } from '../../../types/DataDelivery';

const useBuildConfigs = (orgId: string) => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (clientProjectId: string) => {
      const response = await axios.post<SapConfig[]>(`data_wrangling/${clientProjectId}/configs/build`);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['clientProjects', orgId], { refetchInactive: true });
      },
    }
  );
};

export default useBuildConfigs;
